export default __webpack_public_path__ + "static/media/Learning.4cf8922815d8bb70817058f694fd7e46.webp";